import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import TermsConditions from '@/views/TermsConditions.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/terms-and-conditions',
    name: 'TermsConditions',
    component: TermsConditions,
  },
]

const router = new VueRouter({
  routes,
  mode: 'history',
})
/* Make sure the page loads at the top */
router.afterEach(() => {
  window.scrollTo(0, 0)
})

export default router
